import React, { useState, useEffect, useReducer, useRef } from "react";
import { Container, Nav, Modal } from "react-bootstrap";
import { AiOutlineRight, AiFillCopy } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import { useStoreState, useStoreDispatch, APP_STORE_ACTION } from '../../common/storeContext'
import { TENANT_BUCKET, GLOBAL_BUCKET, GAME_MENU_DATA } from '../../common/constants'
import TransferBalanceDialog from '../../components/TransferBalanceDialog'
import PromoDetailsDialog from '../../components/PromoDetailsDialog'
import PngGameLauncher from '../../components/PngGameLauncher'
import Loading from '../../components/Loading';
import Alert from '../../components/Alert'
import ImageWithPlaceholder from '../../components/ImageWithPlaceholder'
import { useMiddletier } from "../../common/middletier";
import { useNavigate, useLocation } from "react-router-dom";
import dayjs from 'dayjs';

import "swiper/css";
import "swiper/css/pagination";
import "./template_03.css";

import PlayTechGameLauncher from '../../components/PlayTechGameLauncher'


const DYNAMIC_ACTION = {
  SET_DEFAULT_DATA: 'SET_DEFAULT_DATA',
  SET_SHOW_DATA: 'SET_SHOW_DATA',
  SET_FILTER_TYPES: 'SET_FILTER_TYPES',
  SET_SELECTED_FILTER_TYPE: 'SET_SELECTED_FILTER_TYPE',
  SET_ALL_TYPES: 'SET_ALL_TYPES',
  UPDATE_COUNTDOWN: 'UPDATE_COUNTDOWN',
  SET_SELECTED_DATA: 'SET_SELECTED_DATA',
  selectedData: {}
}

const initialDynamicData = {
  defaultData: [],
  showData: [],
  // filterTypes: [{ code: 'all', name: 'show_all' }],
  // selectedFilterType: { code: 'all', name: 'show_all' },
  allType: [],
  filterTypes: [{ code: 'ALL', name: 'show_all' }],
  selectedFilterType: { code: 'ALL', name: 'show_all' },
}

const dynamicReducer = (state, action) => {
  switch (action.type) {

    case DYNAMIC_ACTION.SET_DEFAULT_DATA: {
      const defaultData = action.payload
      return { ...state, defaultData };
    }

    case DYNAMIC_ACTION.SET_SHOW_DATA: {
      const showData = action.payload
      return { ...state, showData };
    }

    case DYNAMIC_ACTION.UPDATE_COUNTDOWN: {
      const updateCountdown = state.showData.map(promotion => ({
        ...promotion, remainingTime: action.payload(promotion)
      }));

      return { ...state, showData: updateCountdown };
    }


    case DYNAMIC_ACTION.SET_ALL_TYPES: {
      const allType = [...action.payload]
      return { ...state, allType };
    }

    case DYNAMIC_ACTION.SET_FILTER_TYPES: {
      const filterTypes = [...action.payload]
      return { ...state, filterTypes };
    }

    case DYNAMIC_ACTION.SET_SELECTED_FILTER_TYPE: {
      const selectedFilterType = state.filterTypes.find((filterTypes) => filterTypes.code === action.payload)
      return { ...state, selectedFilterType };
    }


    case DYNAMIC_ACTION.SET_SELECTED_DATA: {
      const selectedData = action.payload
      return { ...state, selectedData };
    }

    default: {
      throw new Error(`Unhandled action type: ${action.type}`)
    }
  }
}

const Template_03 = (props) => {

  const appState = useStoreState()
  // const [dynamicData, setDynamicData] = useState();
  const [dynamicState, dynamicDispatch] = useReducer(dynamicReducer, initialDynamicData)
  const { query, queries, mutation } = useMiddletier();
  const appDispatch = useStoreDispatch()
  // const [remainingTime, setRemainingTime] = useState(null);
  const location = useLocation();
  const [promoDetailsDialogShow, setPromoDetailsDialogShow] = useState(false);
  const [transferDialogShow, setTransferDialogShow] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const navigate = useNavigate();
  const cardContainerProps = props.properties ? props.properties.find((itm) => itm.name === 'Card Container') : false
  const { desktopToggle, mobileToggle, label, id, dataType, titleToggle, titleIconToggle, dynamicQuery, data, filter, noPadding, filterTabToggle, cardPosition, noLink } = props;
  const isSafari = () => /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);

  const checkProps = cardContainerProps ? cardContainerProps : props;
  const { contentPosition, actionPosition, rowDesktop, rowMobile, numberOfRow } = checkProps
  const imageSize = cardContainerProps.image ? cardContainerProps.image : props.imageSize

  const { t, i18n } = useTranslation();
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 992px)'
  })

  const [deviceType, setDeviceType] = useState('');
  const [isInAppBrowser, setIsInAppBrowser] = useState(false);
  const [isLoadingTransfer, setLoadingTransfer] = useState(false);

  const gameWindowRef = useRef(null);
  const playtechGameLauncherRef = useRef();
  const [playtectParams, setPlaytechParams] = useState("");
  const [showPlaytechGameLauncher, setShowPlaytechGameLauncher] = useState(false);
  const [showPngGameLauncher, setShowPngGameLauncher] = useState(false);

  const [iframeShow, setIframeShow] = useState(false);

  const [pngGameSetup, setPngGameSetup] = useState({ gameUrl: "", eventTypes: [{}] });
  const [showGameCancelPromotionDialog, setShowGameCancelPromotionDialog] = useState(false);
  const [isActionVisible, setIsActionVisible] = useState(false);

  const onChangeType = (newValue) => {
    dynamicDispatch({ type: DYNAMIC_ACTION.SET_SELECTED_FILTER_TYPE, payload: newValue })
  }

  const copyText = (newValue) => {
    navigator.clipboard.writeText(newValue);

    appDispatch({
      type: APP_STORE_ACTION.SHOW_ALERT,
      payload: { description: `Copied ${newValue}`, typeAlert: 'success' }
    });
  };


  const onChangePromoDetails = (item) => {
    setCurrentItem(item);
    setPromoDetailsDialogShow(true);
  };

  const onClickGame = (e, game, details) => {

    console.log('on click game')

    if (e && typeof e?.stopPropagation === 'function') {
      e.stopPropagation();
    }

    if (appState.loggedIn) {
      setLoading(true);
      // --------------------------------------------------------------
      let currentGame = {
        getCurrentGameType: '',
        getCurrentGameProvider: '',
        getCurrentGameCode: '',
        getCurrentGameUrl: '',
        getCurrentGameAfterGameLink: false,
      }

      if (dataType === 'game provider') {
        // console.log(game)
        // console.log('game_provider_game_types',game._game_provider_game_types)
        currentGame.getCurrentGameType = game._game_provider_game_types[0].type
        currentGame.getCurrentGameProvider = game.game_provider
        currentGame.getCurrentGameCode = game.code
        currentGame.getCurrentGameAfterGameLink = game.auto_transfer_after_game_link
      }
      else if (dataType === 'game') {
        currentGame.getCurrentGameType = game.type
        currentGame.getCurrentGameProvider = game.game_provider
        currentGame.getCurrentGameCode = game.code
      } else {
        currentGame.getCurrentGameType = game.sub_type
        currentGame.getCurrentGameProvider = game.game_provider
        currentGame.getCurrentGameCode = game.code
      }

      // --------------------------------------------------------
      // IF CURRENT PROMOTION IS NORMAL AND PLAYER CLICK FREE CREDIT
      // IF CURRENT PROMOTION IS FREECREDIT AND PLAYER CLICK PLAYNOW

      if (details?.confirmUnlock === undefined && game?.current_promotion_application !== null && ((game?.current_promotion_application?.promotion_type !== 'FREE_CREDIT' && details?.freeCredit) || game?.current_promotion_application?.promotion_type === 'FREE_CREDIT' && !details?.freeCredit)) {
        setLoading(false);
        dynamicDispatch({ type: DYNAMIC_ACTION.SET_SELECTED_DATA, payload: { game, details } })
        console.log('check got current promotion', { game, details })
        setShowGameCancelPromotionDialog(true)
      } else {

        let mytab

        if (!isInAppBrowser && currentGame.getCurrentGameProvider !== 'PLAYNGO' && currentGame.getCurrentGameProvider !== 'PLAYTECH' && currentGame.getCurrentGameProvider !== 'PLAYTECH_LC') {
          // OPEN NEW TAB FOR GAME
          mytab = window.open("/loading.html", "_blank");
        }


        // IF GAME PROVIDER AUTO TRANSFER AFTER GAME LINK TRUE (RESTORE FIRST THEN CALL GET GAME LINK)
        if ((dataType === 'game provider' && currentGame.getCurrentGameAfterGameLink)) {

          mutation([{
            method: 'restoreGameWalletByMember',
            params: [
              { code: 'gameProvider', graphqlType: 'String', required: true, value: currentGame.getCurrentGameProvider },
              { code: 'checkAutoTransfer', graphqlType: 'Boolean', required: false, value: true },
            ],
            attributes: []

          }])
            .then(({ data }) => {
              if (!isInAppBrowser && currentGame.getCurrentGameProvider !== 'PLAYNGO' && currentGame.getCurrentGameProvider !== 'PLAYTECH' && currentGame.getCurrentGameProvider !== 'PLAYTECH_LC') {
                mytab.location = '/loading_transfer.html'
              } else {
                setLoading(false);
                setLoadingTransfer(true);
              }
              // mytab.location = '/loading_transfer.html'

              let params = [
                { code: 'gameProvider', graphqlType: 'String', required: true, value: currentGame.getCurrentGameProvider },
                { code: 'device', graphqlType: 'String', required: false, value: deviceType === 'desktop' ? '0' : '1' },
                { code: 'gameType', graphqlType: 'String', required: true, value: currentGame.getCurrentGameType },
                { code: 'game', graphqlType: 'String', required: false, value: currentGame.getCurrentGameCode },
                { code: 'language', graphqlType: 'String', required: false, value: i18n.resolvedLanguage },
                { code: 'skipTransfer', graphqlType: 'Boolean', required: false, value: true },
                { code: 'isFreeCredit', graphqlType: 'Boolean', required: false, value: details?.freeCredit ? true : false },
              ]

              if (details?.freeCredit) {
                params?.push({ code: 'freeCreditPromotion', graphqlType: 'String', required: false, value: details?.freeCredit ? game?.free_credit_promotion : '' })
              }

              if (details?.confirmUnlock !== undefined) {
                params?.push({ code: 'forceUnlock', graphqlType: 'Boolean', required: false, value: details?.confirmUnlock ? true : false },)
              }
              query({
                method: 'getGameLinkByMember',
                params,
                attributes: []

              }).then(({ data }) => {

                const gameBalance = data['getGameLinkByMember'].balance
                const gameUrl = data['getGameLinkByMember'].gameLink
                const gameWalletAmount = data['getGameLinkByMember'].wallet_amount
                const gameMaintenance = data['getGameLinkByMember']?.is_maintenance

                currentGame.getCurrentGameUrl = gameUrl

                if (gameUrl === "" || gameMaintenance) {
                  setLoading(false);

                  if (!isInAppBrowser && currentGame.getCurrentGameProvider !== 'PLAYNGO' && currentGame.getCurrentGameProvider !== 'PLAYTECH' && currentGame.getCurrentGameProvider !== 'PLAYTECH_LC') {
                    mytab.close()
                  } else {
                    setLoadingTransfer(false);
                  }
                  // mytab.close()
                  const getResponse = JSON.parse(data['getGameLinkByMember']?.response)
                  const getResponseErrorMsg = getResponse?.errMsg

                  appDispatch({
                    type: APP_STORE_ACTION.SHOW_ALERT,
                    payload: { description: gameMaintenance ? t('under_maintenance') : getResponseErrorMsg, typeAlert: 'error' }
                  });

                  return
                } else {

                  if (!isInAppBrowser && currentGame.getCurrentGameProvider !== 'PLAYNGO' && currentGame.getCurrentGameProvider !== 'PLAYTECH' && currentGame.getCurrentGameProvider !== 'PLAYTECH_LC') {
                    mytab.location = gameUrl
                  } else {
                    setLoadingTransfer(false);
                  }
                  // mytab.location = gameUrl

                  if (gameBalance === 0 && data['restoreGameWalletByMember'] === 0) {
                    setLoading(false);
                    setLoadingTransfer(false);
                    setTransferDialogShow({ show: true, balance: gameBalance, gameSelect: { ...currentGame }, walletAmount: gameWalletAmount });
                  } else {
                    if (isInAppBrowser) {
                      window.location.href = gameUrl;
                    }
                    queries([{
                      index: 'getAllGamePrivoderBalanceByMember',
                      method: 'getAllGamePrivoderBalanceByMember',
                      params: [],
                      attributes: []
                    },
                    {
                      index: 'getMember',
                      method: 'getMember',
                      params: [
                        { code: 'filter', graphqlType: 'JSON', required: true, value: { where: { username: appState.user.username } } }
                      ],
                      attributes: ['wallet_amount']
                    },])
                      .then(({ data }) => {

                        setLoading(false);
                        setLoadingTransfer(false);
                        appDispatch({ type: APP_STORE_ACTION.REFRESH_GET_GAME_WALLET, payload: data['getAllGamePrivoderBalanceByMember'] })
                        appDispatch({ type: APP_STORE_ACTION.REFRESH_WALLET_AMOUNT, payload: data['getMember']?.[0]?.wallet_amount })


                      }).catch((error) => {
                        // console.log('error: ', error)
                        setLoading(false)
                        setLoadingTransfer(false);
                        if (error?.networkError?.statusCode === 401) {
                          appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
                        } else {
                          appDispatch({
                            type: APP_STORE_ACTION.SHOW_ALERT,
                            payload: { description: error.message.toString(), typeAlert: 'error' }
                          });
                        }
                      })
                  }




                }

              }).catch((error) => {
                // mytab.close()
                if (!isInAppBrowser && currentGame.getCurrentGameProvider !== 'PLAYNGO' && currentGame.getCurrentGameProvider !== 'PLAYTECH' && currentGame.getCurrentGameProvider !== 'PLAYTECH_LC') {
                  mytab.close()
                }
                setLoading(false);
                // console.log('error: ', error)
                if (error?.networkError?.statusCode === 401) {
                  appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
                } else {
                  appDispatch({
                    type: APP_STORE_ACTION.SHOW_ALERT,
                    payload: { description: error.message.toString(), typeAlert: 'error' }
                  });
                }
              })

            })
            .catch((error) => {
              // console.log('error: ', error)
              // mytab.close()
              if (!isInAppBrowser && currentGame.getCurrentGameProvider !== 'PLAYNGO' && currentGame.getCurrentGameProvider !== 'PLAYTECH' && currentGame.getCurrentGameProvider !== 'PLAYTECH_LC') {
                mytab.close()
              }
              setLoading(false)
              if (error?.networkError?.statusCode === 401) {
                appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
              } else {
                appDispatch({
                  type: APP_STORE_ACTION.SHOW_ALERT,
                  payload: { description: error.message.toString(), typeAlert: 'error' }
                });
              }
            })




        } else {
          let method = 'getGameLinkByMember';
          let params = [
            { code: 'gameProvider', graphqlType: 'String', required: true, value: currentGame.getCurrentGameProvider },
            { code: 'device', graphqlType: 'String', required: false, value: deviceType === 'desktop' ? '0' : '1' },
            { code: 'gameType', graphqlType: 'String', required: true, value: currentGame.getCurrentGameType },
            { code: 'game', graphqlType: 'String', required: false, value: currentGame.getCurrentGameCode },
            { code: 'language', graphqlType: 'String', required: false, value: i18n.resolvedLanguage },
            { code: 'skipTransfer', graphqlType: 'Boolean', required: false, value: true },
            { code: 'isFreeCredit', graphqlType: 'Boolean', required: false, value: details?.freeCredit ? true : false },
          ];

          if (details?.freeCredit) {
            params?.push({ code: 'freeCreditPromotion', graphqlType: 'String', required: false, value: details?.freeCredit ? game?.free_credit_promotion : '' })
          }

          if (details?.confirmUnlock !== undefined) {
            params?.push({ code: 'forceUnlock', graphqlType: 'Boolean', required: false, value: details?.confirmUnlock },)
          }

          query({
            method,
            params,
            attributes: []

          }).then(({ data }) => {
            // setLoading(false)
            // console.log('getGameLinkByMember', data[method])

            const gameBalance = data[method].balance
            const gameUrl = data[method].gameLink
            const gameWalletAmount = data[method].wallet_amount
            const gameMaintenance = data[method]?.is_maintenance
            currentGame.getCurrentGameUrl = gameUrl

            if (gameUrl === "" || gameMaintenance) {
              setLoading(false);
              mytab?.close()
              const getResponse = JSON.parse(data[method]?.response)
              const getResponseErrorMsg = getResponse?.errMsg

              appDispatch({
                type: APP_STORE_ACTION.SHOW_ALERT,
                payload: { description: gameMaintenance ? t('under_maintenance') : getResponseErrorMsg, typeAlert: 'error' }
              });

              return
            } else {

              if (!isInAppBrowser && currentGame.getCurrentGameProvider !== 'PLAYNGO' && currentGame.getCurrentGameProvider !== 'PLAYTECH' && currentGame.getCurrentGameProvider !== 'PLAYTECH_LC') {
                mytab.location = '/loading_transfer.html'
              } else {
                setLoading(false);
                setLoadingTransfer(true);
              }

              mutation([{
                method: 'restoreGameWalletByMember',
                params: [
                  { code: 'gameProvider', graphqlType: 'String', required: true, value: currentGame.getCurrentGameProvider },
                  { code: 'checkAutoTransfer', graphqlType: 'Boolean', required: false, value: true },
                ],
                attributes: []

              }])
                .then(({ data }) => {
                  // console.log('data[restoreGameWalletByMember]', data['restoreGameWalletByMember'])

                  if (!isInAppBrowser && currentGame.getCurrentGameProvider !== 'PLAYNGO' && currentGame.getCurrentGameProvider !== 'PLAYTECH' && currentGame.getCurrentGameProvider !== 'PLAYTECH_LC') {
                    mytab.location = gameUrl
                  } else {
                    setLoadingTransfer(false);

                  }

                  if (gameBalance === 0 && data['restoreGameWalletByMember'] === 0) {
                    setLoading(false);
                    setLoadingTransfer(false);
                    setTransferDialogShow({ show: true, balance: gameBalance, gameSelect: { ...currentGame }, walletAmount: gameWalletAmount });
                  }

                  else {
                    if (isInAppBrowser && currentGame.getCurrentGameProvider !== 'PLAYNGO' && currentGame.getCurrentGameProvider !== 'PLAYTECH' && currentGame.getCurrentGameProvider !== 'PLAYTECH_LC') {
                      window.location.href = gameUrl;
                    }

                    if (currentGame.getCurrentGameProvider === 'PLAYTECH' || currentGame.getCurrentGameProvider === 'PLAYTECH_LC') {
                      setPlaytechParams(JSON.parse(gameUrl));
                      setIframeShow(true)
                      setShowPngGameLauncher(false);
                      setShowPlaytechGameLauncher(true);

                      window.history.pushState({ iframe: true }, "iframe");

                      setTimeout(() => {
                        if (playtechGameLauncherRef.current && typeof playtechGameLauncherRef.current.login === "function") {
                          playtechGameLauncherRef.current.login();
                        } else {
                          console.error("PlaytechGameLauncher is not ready.");
                        }
                      }, 0);
                    }

                    if (currentGame.getCurrentGameProvider === 'PLAYNGO') {
                      console.log('click png')
                      setIframeShow(true)
                      setShowPngGameLauncher(true);
                      setShowPlaytechGameLauncher(false);
                      window.history.pushState({ iframe: true }, "iframe");
                      setPngGameSetup({
                        gameUrl: gameUrl,
                        eventTypes: [
                          { eventType: "gameReady", call: () => console.log("Game is ready") },
                          { eventType: "reloadGame", call: () => window.location.reload() },
                          { eventType: "backToLobby", call: () => window.location.reload() },
                        ]
                      });
                    }

                    queries([{
                      index: 'getAllGamePrivoderBalanceByMember',
                      method: 'getAllGamePrivoderBalanceByMember',
                      params: [],
                      attributes: []
                    },
                    {
                      index: 'getMember',
                      method: 'getMember',
                      params: [
                        { code: 'filter', graphqlType: 'JSON', required: true, value: { where: { username: appState.user.username } } }
                      ],
                      attributes: ['wallet_amount']
                    },])
                      .then(({ data }) => {

                        setLoading(false);
                        setLoadingTransfer(false);
                        appDispatch({ type: APP_STORE_ACTION.REFRESH_GET_GAME_WALLET, payload: data['getAllGamePrivoderBalanceByMember'] })
                        appDispatch({ type: APP_STORE_ACTION.REFRESH_WALLET_AMOUNT, payload: data['getMember']?.[0]?.wallet_amount })


                      }).catch((error) => {
                        // console.log('error: ', error)
                        setLoading(false)
                        setLoadingTransfer(false);
                        if (error?.networkError?.statusCode === 401) {
                          appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
                        } else {
                          appDispatch({
                            type: APP_STORE_ACTION.SHOW_ALERT,
                            payload: { description: error.message.toString(), typeAlert: 'error' }
                          });
                        }
                      })

                  }

                })
                .catch((error) => {
                  // console.log('error: ', error)
                  setLoading(false)
                  if (error?.networkError?.statusCode === 401) {
                    appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
                  } else {
                    appDispatch({
                      type: APP_STORE_ACTION.SHOW_ALERT,
                      payload: { description: error.message.toString(), typeAlert: 'error' }
                    });
                  }
                })
            }



          }).catch((error) => {
            // mytab.close()
            if (!isInAppBrowser && currentGame.getCurrentGameProvider !== 'PLAYNGO' && currentGame.getCurrentGameProvider !== 'PLAYTECH' && currentGame.getCurrentGameProvider !== 'PLAYTECH_LC') {
              mytab.close()
            }
            setLoading(false);
            // console.log('error: ', error)
            if (error?.networkError?.statusCode === 401) {
              appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
            } else {
              appDispatch({
                type: APP_STORE_ACTION.SHOW_ALERT,
                payload: { description: error.message.toString(), typeAlert: 'error' }
              });
            }
          })
        }

      }

    }
    else {
      appDispatch({
        type: APP_STORE_ACTION.SHOW_ALERT,
        payload: { description: t('error_login_continue'), typeAlert: 'error' }
      });
    }

  }



  // GET DATA
  useEffect(() => {
    let filterValue, getDynamicQuery

    if (dataType === 'game provider') {
      // console.log('gameprovider',filter)
      // console.log('dynamicQuery',dynamicQuery)
      if (dynamicQuery !== '') {
        getDynamicQuery = appState.dataTypes?.gameProviders[dynamicQuery]?.where ?? false
      }

      filterValue = {
        where: { '$_game_provider_game_types.type$': `${filter}`, '$_game_provider_game_types.status$': `ACTIVE`, status: 'ACTIVE', ...(getDynamicQuery ? getDynamicQuery : {}) },
        order: [['index', 'ASC'], ['name', 'ASC']]
      };

      query({
        method: 'getGameProviders',
        params: [
          { code: 'filter', graphqlType: 'JSON', required: true, value: filterValue },
        ],
        attributes: [['code', 'game_provider'], ['_game_provider_game_types', ['type']], 'name', 'live_link', 'auto_transfer_after_game_link', 'is_maintenance','hot','new']

      }).then(({ data }) => {

        dynamicDispatch({ type: DYNAMIC_ACTION.SET_SHOW_DATA, payload: data['getGameProviders'] })

      }).catch((error) => {
        // console.log('error: ', error)
      })

    }
    else if (dataType === 'game') {

      if (dynamicQuery !== '') {
        getDynamicQuery = appState.dataTypes?.games[dynamicQuery].where
      }

      filterValue = { where: { type: `${filter}`, '$_game_provider.status$': `ACTIVE`, status: 'ACTIVE', ...(getDynamicQuery ? getDynamicQuery : {}) }, limit: 12 };


      query({
        method: 'getGames',
        params: [
          { code: 'filter', graphqlType: 'JSON', required: true, value: filterValue },
        ],
        attributes: []
      }).then(({ data }) => {

        //GAME_${code}
        const sortedGameData = data['getGames']?.filter(item => item.is_maintenance === false).sort((a, b) => {

          // check if ranking is null
          const aRank = a.ranking === null ? -1 : a.ranking;
          const bRank = b.ranking === null ? -1 : b.ranking;

          if (aRank !== -1 && bRank === -1) return -1;
          if (aRank === -1 && bRank !== -1) return 1;
          if (aRank !== -1 && bRank !== -1) {
            return aRank - bRank;
          }
          return 0;
        });

        console.log('template 3 game', sortedGameData)

        dynamicDispatch({ type: DYNAMIC_ACTION.SET_SHOW_DATA, payload: sortedGameData })

      }).catch((error) => {
        // console.log('error: ', error)
      })

    }
    else if (dataType === 'promotion') {

      queries([{
        index: 'getPromotions',
        method: 'getPromotions',
        params: [
          { code: 'language', graphqlType: 'String', required: true, value: i18n.resolvedLanguage },
          { code: 'appearInWebsite', graphqlType: 'Boolean', required: false, value: true },
          { code: 'haveImage', graphqlType: 'Boolean', required: false, value: true },
        ],
        attributes: []
      }, {
        index: 'getPromotionCategories',
        method: 'getPromotionCategories',
        params: [
          { code: 'filter', graphqlType: 'JSON', required: true, value: { where: { status: 'ACTIVE' } } },
        ],
        attributes: ['code', 'name']
      }]).then(({ data }) => {

        const getPromotionsData = data['getPromotions']?.map((item) => {
          return { ...item, category: JSON.parse(item.category) };
        })

        // console.log('getPromotionsData: ', getPromotionsData)
        // const getPromoTypes = getPromotionsData.reduce((result, promo) => {
        //   promo.category.forEach((t) => {
        //     if (result.indexOf(t) === -1) {
        //       result.push(t);
        //     }
        //   });
        //   return result
        // }, ["ALL"])



        //  const getPromoTypes = ['ALL', ...data['getPromotionCategories'].map(item => item)];
        const getPromoTypes = [{ code: 'ALL', name: 'show_all' }, ...data['getPromotionCategories'].map(item => item)];

        // console.log('getPromoTypes', getPromoTypes)

        dynamicDispatch({ type: DYNAMIC_ACTION.SET_ALL_TYPES, payload: data['getPromotionCategories'] })
        dynamicDispatch({ type: DYNAMIC_ACTION.SET_FILTER_TYPES, payload: getPromoTypes })
        dynamicDispatch({ type: DYNAMIC_ACTION.SET_DEFAULT_DATA, payload: getPromotionsData })
        dynamicDispatch({ type: DYNAMIC_ACTION.SET_SHOW_DATA, payload: getPromotionsData })

        // console.log('promo', data['getPromotions'])
      }).catch((error) => {
        // console.log('error: ', error)
      })

    }
    else if (dataType === 'gameTypes') {
      query({
        method: 'getGameTypes',
        params: [
          { code: 'filter', graphqlType: 'JSON', required: true, value: { where: { status: 'ACTIVE', game_provider: `GS` } } }
        ],
        attributes: [['type', 'code'], 'coming_soon', ['_type', ['index']]]

      }).then(({ data }) => {

        // Filter out objects with code 'APP' because currently 'APP' is grouped with 'SL'
        const getNewGameType = data['getGameTypes']?.filter(item => item.code !== 'APP')?.sort((a, b) => a._type?.index == null ? 1 : b._type?.index == null ? -1 : Number(a._type?.index) - Number(b._type?.index) );

        dynamicDispatch({ type: DYNAMIC_ACTION.SET_SHOW_DATA, payload: getNewGameType })

      }).catch((error) => {
        // console.log('error: ', error)
      })
    }
    else {
      dynamicDispatch({ type: DYNAMIC_ACTION.SET_SHOW_DATA, payload: data })
      // setDynamicData(data)

    }

  }, [query, queries, data, dataType, filter, i18n.resolvedLanguage, appState.dataTypes?.gameProviders, appState.dataTypes?.games, dynamicQuery])
  const RemainingTime = ({ lastEffectiveDate }) => {
    const [remainingTime, setRemainingTime] = useState(null);
    const year = dayjs(lastEffectiveDate).year()

    useEffect(() => {
      // const promotionEndTime = dayjs(`${lastEffectiveDate}T${displayEndTime}`);
      const promotionEndTime = dayjs(`${lastEffectiveDate}`);

      const intervalId = setInterval(() => {
        const now = dayjs();
        const timeRemaining = promotionEndTime.diff(now);

        const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

        setRemainingTime({ days, hours, minutes, seconds });
      }, 1000);

      return () => clearInterval(intervalId);
    }, [lastEffectiveDate]);

    return (
      <div className="w-50">
        {remainingTime && (
          <div className="promoDetails_timeShow promotionTime_part">
            <div className="promoDetails_timeShow_container">
              {year >= 2999 ? (<>No Expire Date</>) : (<><div className="count_container day_count">
                <div className="count_box">
                  <p>{remainingTime?.days}</p>
                  <p>{t('days')}</p>
                </div>
              </div>
                <div className="count_container time_count">
                  <div className="count_box">
                    <p>{remainingTime?.hours}</p>
                    <p>{t('hour')}</p>
                  </div>
                  <span>:</span>
                  <div className="count_box">
                    <p>{remainingTime?.minutes}</p>
                    <p>{t('min')}</p>
                  </div>
                  <span>:</span>
                  <div className="count_box">
                    <p>{remainingTime?.seconds}</p>
                    <p>{t('sec')}</p>
                  </div>
                </div></>)}

            </div>
          </div>
        )}
      </div>
    );
  };
  const determineLinkTo = (_item, item) => {
    if (dataType === 'gameTypes') {
      if (item.code === _item.gameType && item.coming_soon === true) {
        return null;
      }
      return _item.url;
    }
    if (dataType === 'game provider' && filter === 'SL') {
      return `slots#${item.game_provider}`;
    }

    if (dataType === 'games' || dataType === 'game') {
      return `#${item.game_provider}`;
    }
  };

  const handleLinkClick = (event, item) => {
    console.log('this')
    if (dataType === 'game' || dataType === 'games' || (dataType === 'game provider' && filter !== 'SL')) {
      if (item?.is_maintenance) {
        return appDispatch({
          type: APP_STORE_ACTION.SHOW_ALERT,
          payload: { description: t('under_maintenance'), typeAlert: 'error' }
        });
      }
      else {
        if (!isActionVisible && (dataType === 'game' || dataType === 'games')) {
          setIsActionVisible(true);
          return;
        }else{
          if (actionPosition !== 'bottom' && actionPosition !== 'hover'){
            onClickGame(event, item);
          }
        }
      
      }
    }


    if (noLink) {
      event.preventDefault();
    }

  };

  useEffect(() => {
    const userAgent = navigator.userAgent;

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
      setDeviceType("mobile");
    } else {
      setDeviceType("desktop");
    }

    const isInAppBrowser = /FBAV|FBAN|Instagram|Twitter|Line/i.test(userAgent);

    if (isInAppBrowser) {
      setIsInAppBrowser(true)
    } else {
      setIsInAppBrowser(false)
    }

  }, [])

  const closeIframe = () => {
    setIframeShow(false);
    if (showPlaytechGameLauncher) {
      window.location.reload()
    }
    if (window.history.state?.iframe) {
      window.history.back();
    }
  };

  useEffect(() => {
    const handlePopState = (event) => {
      if (event.state?.iframe) {
        setIframeShow(false);
      }
    };

    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  const widthColumn = isDesktopOrLaptop ? (rowDesktop ? 100 / rowDesktop : 0) : (rowMobile ? 100 / rowMobile : 0)
  const showDataLength = !numberOfRow ? dynamicState.showData?.length : (numberOfRow !== -1 ? (isDesktopOrLaptop ? rowDesktop : rowMobile) * numberOfRow : dynamicState.showData?.length)


  const bigImageData = Object.values(dynamicState.showData ?? "")[0];
  const smallImagesData = Object.values(dynamicState.showData ?? "").slice(1);

  if ((desktopToggle || mobileToggle) === true) {
    return (
      <>
        <section className={`section ${desktopToggle ? "" : "d-lg-none"} ${mobileToggle ? "" : "d-none d-lg-block"} dynamic_template_1 ${noPadding && 'pb-0'}`} id={`layout_03`}>
          <div id={`${id}`}>
            <div className={`${id}_body ${isDesktopOrLaptop ? '' : `${id}_body_m`} layout_body ${noPadding && 'pb-0'}`}>
              <Container>
                {titleToggle ?
                  <div className={`section_header`}>
                    <div className="font_h2 section_title">
                      {titleIconToggle && (<img src={`${TENANT_BUCKET}/icon/${id}_title_icon.png`} alt="title icon" />)}
                      {label && t(label)}</div>
                    <Link to={`../${dataType === 'game' ? 'slots' : (dataType === 'game provider' ? `${GAME_MENU_DATA[filter].url}` : (dataType === 'promotion' ? 'promotions' : ''))}`} className="section_details">
                      {t('view_more')} &nbsp;
                      <AiOutlineRight />
                    </Link>
                  </div>
                  : <></>}
                {/* <div className="row layout_template3">
              <div className="col-md-4 d-none d-md-block main_pic">
               <ImageWithPlaceholder src={`${GLOBAL_BUCKET}/game/${bigImageData?.game_provider}/${imageSize}/${bigImageData?.code}.png`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={bigImageData?.title} />
              </div>
              <div className="col-md-8 col-12">
                <div className="row">
                  <div className="col-4">
                    <div className="mb-1">
                     <ImageWithPlaceholder src={`${GLOBAL_BUCKET}/game/${bigImageData?.game_provider}/${imageSize}/${bigImageData?.code}.png`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={bigImageData?.title} />
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="mb-1">
                     <ImageWithPlaceholder src={`${GLOBAL_BUCKET}/game/${bigImageData?.game_provider}/${imageSize}/${bigImageData?.code}.png`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={bigImageData?.title} />
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="mb-1">
                     <ImageWithPlaceholder src={`${GLOBAL_BUCKET}/game/${bigImageData?.game_provider}/${imageSize}/${bigImageData?.code}.png`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={bigImageData?.title} />
                    </div>
                  </div>
                 
                </div>
                <div className="row">
                  <div className="col-4">
                    <div className="mt-2">
                     <ImageWithPlaceholder src={`${GLOBAL_BUCKET}/game/${bigImageData?.game_provider}/${imageSize}/${bigImageData?.code}.png`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={bigImageData?.title} />
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="mt-2">
                     <ImageWithPlaceholder src={`${GLOBAL_BUCKET}/game/${bigImageData?.game_provider}/${imageSize}/${bigImageData?.code}.png`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={bigImageData?.title} />
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="mt-2">
                     <ImageWithPlaceholder src={`${GLOBAL_BUCKET}/game/${bigImageData?.game_provider}/${imageSize}/${bigImageData?.code}.png`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={bigImageData?.title} />
                    </div>
                  </div>
                 
                </div>
              </div>
            </div> */}

                {/* <div class="box">
              <div class="left">  <ImageWithPlaceholder src={`${GLOBAL_BUCKET}/game/${bigImageData?.game_provider}/${imageSize}/${bigImageData?.code}.png`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={bigImageData?.title} /></div>
              <div class="right">
                <div>  <ImageWithPlaceholder src={`${GLOBAL_BUCKET}/game/${bigImageData?.game_provider}/${imageSize}/${bigImageData?.code}.png`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={bigImageData?.title} /></div>
                <div>  <ImageWithPlaceholder src={`${GLOBAL_BUCKET}/game/${bigImageData?.game_provider}/${imageSize}/${bigImageData?.code}.png`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={bigImageData?.title} /></div>
              </div>
            </div> */}

                {/* --- SECTION BODY START --- */}
                <div className={`row template_row`}>
                  {imageSize === '1x2' ? (<>
                    <div className={`main-image card_container ${bigImageData?.is_maintenance ? 'maintenance_status' : ''}`}>
                      <div className={`card_wrap card_image_${imageSize} card_position_${contentPosition} card_action_${actionPosition} type_${dataType}`} onClick={(event) => handleLinkClick(event, bigImageData)}>
                        {/* --- IMAGE PART START --- */}
                        <figure className={`card_image_wrap ${bigImageData?.coming_soon ? 'coming_soon_image' : ''}`}>
                        {(dataType === 'game provider' && bigImageData?.hot) && (
                                <div className="gameProvider_hot_icon">
                                  <img src={`${TENANT_BUCKET}/icon/hot_icon.png`} alt={'hot'} />
                                </div>
                              )}
                              {(dataType === 'game provider' && bigImageData?.new) && (
                                <div className="gameProvider_new_icon">
                                  <img src={`${TENANT_BUCKET}/icon/gameProvider_new_icon.png`} alt={'new'} />
                                </div>
                              )}
                          {(dataType === 'game' || dataType === 'games') ?
                            <ImageWithPlaceholder src={`${GLOBAL_BUCKET}/game/${bigImageData?.game_provider}/${imageSize}/img_jpg/${bigImageData?.code}_${imageSize}_w${imageSize === '1x2' ? '750' : '320'}.jpg`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={bigImageData?.title} /> :
                            (dataType === 'game provider' ?
                              <ImageWithPlaceholder src={`${TENANT_BUCKET}/game-provider/${imageSize}/${filter}/${bigImageData?.game_provider}.png`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={bigImageData.title} /> :
                              (dataType === 'gameTypes' ?
                                <ImageWithPlaceholder src={`${TENANT_BUCKET}/game-type/${imageSize}/${bigImageData.code}${bigImageData?.coming_soon ? '_coming_soon_' : '_'}${i18n.resolvedLanguage}.png`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={bigImageData.title} /> :
                                ((dataType === 'promotion' || dataType === 'promotions') ?
                                  <ImageWithPlaceholder src={`${isDesktopOrLaptop ? (bigImageData?._desktop_image?.url) : (bigImageData?._mobile_image?.url)}`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={bigImageData.title} /> :
                                  <ImageWithPlaceholder src={`${GLOBAL_BUCKET}/game/${bigImageData?.game_provider}/${imageSize}/${bigImageData?.code}.png`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={bigImageData.title} />)
                              ))
                          }
                          {/* IMAGE PART CAPTION */}
                          {contentPosition === 'insideImage' && (<figcaption> <div className="card_content_title">   {
                            (dataType === 'game' || dataType === 'games') ?
                              <>{(t(`GAME_${bigImageData?.id}`))}</> :
                              ((dataType === 'promotion' || dataType === 'promotions') ?
                                <>{bigImageData?.title}</> :
                                <>{bigImageData?.name}</>
                              )

                          }</div></figcaption>)}

                          {/* --- ACTIVE HOVER (INSIDE IMAGE PART) START --- */}
                          {(isActionVisible || isDesktopOrLaptop)&&actionPosition === 'hover' && <div className="card_action_wrap">
                            {
                              (dataType === 'game' || dataType === 'games') ?
                                <>
                                  <button className="color_button font_button button_action button_action1" onClick={(e) => onClickGame(e, bigImageData, { freeCredit: false })}>{bigImageData.action_1 ?? t('play_now')}</button>
                                  {bigImageData?.has_free_credit && (<button className="color_button font_button button_action button_action2" onClick={(e) => onClickGame(e, bigImageData, { freeCredit: true })}>{bigImageData.action_2 ?? t('free_credit')}</button>)}
                                </> :
                                ((dataType === 'promotion' || dataType === 'promotions') ?
                                  <>
                                    <button className="color_button font_button button_action button_action1" onClick={() => onChangePromoDetails(bigImageData)} >{bigImageData.action_1 ?? t('more_info')}</button>
                                    {!appState.loggedIn ?
                                      <button className="color_button font_button button_action button_action2">{bigImageData.action_2 ?? t('join_now')}</button> :
                                      <button className="color_button font_button button_action button_action2">{bigImageData.action_2 ?? t('apply_now')}</button>}
                                  </> :
                                  <></>
                                )

                            }


                          </div>}
                          {/* --- ACTIVE HOVER (INSIDE IMAGE PART) END --- */}

                        </figure>
                        {/* --- IMAGE PART END --- */}
                        {(contentPosition !== 'none' && contentPosition !== 'insideImage') && <div className="color_primary content_container">
                          <article className="card_content_wrap">
                            {
                              ((dataType === 'promotion' || dataType === 'promotions') && Array.isArray(bigImageData.category)) &&
                              <div className="promotionTag_part">
                                {bigImageData.category?.map(function (categoryItem, categoryIndex) {
                                  let _categoryItem = dynamicState.allType.find(e => e.code === categoryItem);
                                  return _categoryItem && (
                                    <label key={categoryIndex}>{_categoryItem.name}</label>
                                  )
                                })}

                                {/* <label>New Member</label>
                                  <label>Slot</label>
                                  <label>Live Casino</label> */}
                              </div>
                            }
                            <div className="card_content_title">   {
                              (dataType === 'game' || dataType === 'games') ?
                                <>{(t(`GAME_${bigImageData?.id}`))}</> :
                                ((dataType === 'promotion' || dataType === 'promotions') ?
                                  <>{bigImageData.title}</> :
                                  <>{bigImageData.name}</>
                                )

                            }</div>
                            <div className="card_content_desc_container">
                              {bigImageData.description && (
                                <p className="card_content_desc">{bigImageData.description}</p>
                              )}
                              {
                                ((dataType === 'promotion' || dataType === 'promotions') && isDesktopOrLaptop) && (
                                  <RemainingTime lastEffectiveDate={bigImageData.last_effective_datetime} />
                                )
                              }
                            </div>
                          </article>

                          {/* --- ACTIVE BOTTOM START --- */}
                          {actionPosition === 'bottom' && <div className="card_action_wrap">
                            <div className="button_action_part">
                              {
                                (dataType === 'game' || dataType === 'games') ?
                                  <>
                                    <button className="color_button font_button button_action button_action1" onClick={(e) => onClickGame(e, bigImageData, { freeCredit: false })}>{bigImageData.action_1 ?? t('play_now')}</button>
                                    {bigImageData?.has_free_credit && (<button className="color_button font_button button_action button_action2" onClick={(e) => onClickGame(e, bigImageData, { freeCredit: true })}>{bigImageData.action_2 ?? t('free_credit')}</button>)}
                                  </>:
                                  ((dataType === 'promotion' || dataType === 'promotions') ?
                              <>
                                <button className="color_button font_button button_action button_action1" onClick={() => onChangePromoDetails(bigImageData)} >{bigImageData.action_1 ?? t('more_info')}</button>
                                {!appState.loggedIn ?
                                  <Link to="/register" className="color_button font_button button_action button_action2">{bigImageData.action_2 ?? t('join_now')}</Link> :
                                  <Link to="/wallet/transfer" className="color_button font_button button_action button_action2">{bigImageData.action_2 ?? t('apply_now')}</Link>}
                              </> :
                              <></>
                              )

                              } </div>
                            {
                              (dataType === 'promotion' || dataType === 'promotions') &&
                              <div className="promotionCode_part">
                                <label>Use Code</label>
                                <div className="promotionCode_content"><p>{bigImageData?.code}</p> <AiFillCopy onClick={() => copyText(bigImageData?.code)} /></div>
                              </div>
                            }


                          </div>}
                          {/* --- ACTIVE BOTTOM END --- */}
                        </div>}

                      </div>
                    </div>
                    <div className="thumbnails">
                      <div className="thumbnail-row">
                        {(dynamicState.showData ?? "").slice(1, 4).map((item, index) => (
                          <div className={`card_container ${item?.is_maintenance ? 'maintenance_status' : ''}`}>
                            <div className={`card_wrap card_image_${imageSize} card_position_${contentPosition} card_action_${actionPosition} type_${dataType}`} onClick={(event) => handleLinkClick(event, item)}>
                              {/* --- IMAGE PART START --- */}
                              <figure className={`card_image_wrap ${item?.coming_soon ? 'coming_soon_image' : ''}`}>
                              {(dataType === 'game provider' && item?.hot) && (
                                <div className="gameProvider_hot_icon">
                                  <img src={`${TENANT_BUCKET}/icon/hot_icon.png`} alt={'hot'} />
                                </div>
                              )}
                              {(dataType === 'game provider' && item?.new) && (
                                <div className="gameProvider_new_icon">
                                  <img src={`${TENANT_BUCKET}/icon/gameProvider_new_icon.png`} alt={'new'} />
                                </div>
                              )}
                                {(dataType === 'game' || dataType === 'games') ?
                                  <ImageWithPlaceholder src={`${GLOBAL_BUCKET}/game/${item.game_provider}/${imageSize}/img_jpg/${item.code}_${imageSize}_w${imageSize === '1x2' ? '320' : '150'}.jpg`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={item.title} /> :
                                  (dataType === 'game provider' ?
                                    <ImageWithPlaceholder src={`${TENANT_BUCKET}/game-provider/${imageSize}/${filter}/${item.game_provider}.png`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={item.title} /> :
                                    (dataType === 'gameTypes' ?
                                      <ImageWithPlaceholder src={`${TENANT_BUCKET}/game-type/${imageSize}/${item.code}${item?.coming_soon ? '_coming_soon_' : '_'}${i18n.resolvedLanguage}.png`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={item.title} /> :
                                      ((dataType === 'promotion' || dataType === 'promotions') ?
                                        <ImageWithPlaceholder src={`${isDesktopOrLaptop ? (item._desktop_image?.url) : (item._mobile_image?.url)}`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={item.title} /> :
                                        <ImageWithPlaceholder src={`${GLOBAL_BUCKET}/game/${item.game_provider}/${imageSize}/${item.code}.png`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={item.title} />)
                                    ))
                                }
                                {/* IMAGE PART CAPTION */}
                                {contentPosition === 'insideImage' && (<figcaption> <div className="card_content_title">   {
                                  (dataType === 'game' || dataType === 'games') ?
                                    <>{(t(`GAME_${item?.id}`))}</> :
                                    ((dataType === 'promotion' || dataType === 'promotions') ?
                                      <>{item.title}</> :
                                      <>{item.name}</>
                                    )

                                }</div></figcaption>)}

                                {/* --- ACTIVE HOVER (INSIDE IMAGE PART) START --- */}
                                {(isActionVisible || isDesktopOrLaptop)&&actionPosition === 'hover' && <div className="card_action_wrap">
                                  {
                                    (dataType === 'game' || dataType === 'games') ?
                                    <>
                                    <button className="color_button font_button button_action button_action1" onClick={(e) => onClickGame(e, item, { freeCredit: false })}>{item.action_1 ?? t('play_now')}</button>
                                    {item?.has_free_credit && (<button className="color_button font_button button_action button_action2" onClick={(e) => onClickGame(e, item, { freeCredit: true })}>{item.action_2 ?? t('free_credit')}</button>)}
                                  </>:
                                      ((dataType === 'promotion' || dataType === 'promotions') ?
                                        <>
                                          <button className="color_button font_button button_action button_action1" onClick={() => onChangePromoDetails(item)} >{item.action_1 ?? t('more_info')}</button>
                                          {!appState.loggedIn ?
                                            <button className="color_button font_button button_action button_action2">{item.action_2 ?? t('join_now')}</button> :
                                            <button className="color_button font_button button_action button_action2">{item.action_2 ?? t('apply_now')}</button>}
                                        </> :
                                        <></>
                                      )

                                  }


                                </div>}
                                {/* --- ACTIVE HOVER (INSIDE IMAGE PART) END --- */}

                              </figure>
                              {/* --- IMAGE PART END --- */}
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="thumbnail-row m-0">

                        {(dynamicState.showData ?? "").slice(4, 7).map((item, index) => (
                          <div className={`card_container ${item?.is_maintenance ? 'maintenance_status' : ''}`}>
                            <div className={`card_wrap card_image_${imageSize} card_position_${contentPosition} card_action_${actionPosition} type_${dataType}`} onClick={(event) => handleLinkClick(event, item)}>
                              {/* --- IMAGE PART START --- */}
                              <figure className={`card_image_wrap ${item?.coming_soon ? 'coming_soon_image' : ''}`} >
                              {(dataType === 'game provider' && item?.hot) && (
                                <div className="gameProvider_hot_icon">
                                  <img src={`${TENANT_BUCKET}/icon/hot_icon.png`} alt={'hot'} />
                                </div>
                              )}
                              {(dataType === 'game provider' && item?.new) && (
                                <div className="gameProvider_new_icon">
                                  <img src={`${TENANT_BUCKET}/icon/gameProvider_new_icon.png`} alt={'new'} />
                                </div>
                              )}
                                {(dataType === 'game' || dataType === 'games') ?
                                  <ImageWithPlaceholder src={`${GLOBAL_BUCKET}/game/${item.game_provider}/${imageSize}/img_jpg/${item.code}_${imageSize}_w${imageSize === '1x2' ? '320' : '150'}.jpg`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={item.title} /> :
                                  (dataType === 'game provider' ?
                                    <ImageWithPlaceholder src={`${TENANT_BUCKET}/game-provider/${imageSize}/${filter}/${item.game_provider}.png`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={item.title} /> :
                                    (dataType === 'gameTypes' ?
                                      <ImageWithPlaceholder src={`${TENANT_BUCKET}/game-type/${imageSize}/${item.code}_${i18n.resolvedLanguage}.png`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={item.title} /> :
                                      ((dataType === 'promotion' || dataType === 'promotions') ?
                                        <ImageWithPlaceholder src={`${isDesktopOrLaptop ? (item._desktop_image?.url) : (item._mobile_image?.url)}`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={item.title} /> :
                                        <ImageWithPlaceholder src={`${GLOBAL_BUCKET}/game/${item.game_provider}/${imageSize}/${item.code}.png`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={item.title} />)
                                    ))
                                }
                                {/* IMAGE PART CAPTION */}
                                {contentPosition === 'insideImage' && (<figcaption> <div className="card_content_title">   {
                                  (dataType === 'game' || dataType === 'games') ?
                                    <>{(t(`GAME_${item?.id}`))}</> :
                                    ((dataType === 'promotion' || dataType === 'promotions') ?
                                      <>{item.title}</> :
                                      <>{item.name}</>
                                    )

                                }</div></figcaption>)}

                                {/* --- ACTIVE HOVER (INSIDE IMAGE PART) START --- */}
                                {(isActionVisible || isDesktopOrLaptop)&&actionPosition === 'hover' && <div className="card_action_wrap">
                                  {
                                    (dataType === 'game' || dataType === 'games') ?
                                    <>
                                  <button className="color_button font_button button_action button_action1" onClick={(e) => onClickGame(e, item, { freeCredit: false })}>{item.action_1 ?? t('play_now')}</button>
                                  {item?.has_free_credit && (<button className="color_button font_button button_action button_action2" onClick={(e) => onClickGame(e, item, { freeCredit: true })}>{item.action_2 ?? t('free_credit')}</button>)}
                                </>:
                                      ((dataType === 'promotion' || dataType === 'promotions') ?
                                        <>
                                          <button className="color_button font_button button_action button_action1" onClick={() => onChangePromoDetails(item)} >{item.action_1 ?? t('more_info')}</button>
                                          {!appState.loggedIn ?
                                            <button className="color_button font_button button_action button_action2">{item.action_2 ?? t('join_now')}</button> :
                                            <button className="color_button font_button button_action button_action2">{item.action_2 ?? t('apply_now')}</button>}
                                        </> :
                                        <></>
                                      )

                                  }


                                </div>}
                                {/* --- ACTIVE HOVER (INSIDE IMAGE PART) END --- */}

                              </figure>
                              {/* --- IMAGE PART END --- */}
                            </div>
                          </div>
                        ))}

                      </div>
                    </div>
                  </>) : (<>   <div className="grid-container">
                    {bigImageData && (<div className={`large-game card_container ${bigImageData?.is_maintenance ? 'maintenance_status' : ''}`}>
                      <div className={`card_wrap card_image_${imageSize} card_position_${contentPosition} card_action_${actionPosition} type_${dataType}`} onClick={(event) => handleLinkClick(event, bigImageData)}>
                        {/* --- IMAGE PART START --- */}
                        <figure className={`card_image_wrap  ${bigImageData?.coming_soon ? 'coming_soon_image' : ''}`}>
                        {(dataType === 'game provider' && bigImageData?.hot) && (
                                <div className="gameProvider_hot_icon">
                                  <img src={`${TENANT_BUCKET}/icon/hot_icon.png`} alt={'hot'} />
                                </div>
                              )}
                              {(dataType === 'game provider' && bigImageData?.new) && (
                                <div className="gameProvider_new_icon">
                                  <img src={`${TENANT_BUCKET}/icon/gameProvider_new_icon.png`} alt={'new'} />
                                </div>
                              )}
                          {(dataType === 'game' || dataType === 'games') ?
                            <ImageWithPlaceholder src={`${GLOBAL_BUCKET}/game/${bigImageData?.game_provider}/${imageSize}/img_jpg/${bigImageData?.code}_${imageSize}_w${imageSize === '1x2' ? '750' : '320'}.jpg`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={bigImageData?.title} /> :
                            (dataType === 'game provider' ?
                              <ImageWithPlaceholder src={`${TENANT_BUCKET}/game-provider/${imageSize}/${filter}/${bigImageData?.game_provider}.png`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={bigImageData.title} /> :
                              (dataType === 'gameTypes' ?
                                <ImageWithPlaceholder src={`${TENANT_BUCKET}/game-type/${imageSize}/${bigImageData?.code}_${i18n.resolvedLanguage}.png`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={bigImageData.title} /> :
                                ((dataType === 'promotion' || dataType === 'promotions') ?
                                  <ImageWithPlaceholder src={`${isDesktopOrLaptop ? (bigImageData?._desktop_image?.url) : (bigImageData?._mobile_image?.url)}`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={bigImageData.title} /> :
                                  <ImageWithPlaceholder src={`${GLOBAL_BUCKET}/game/${bigImageData?.game_provider}/${imageSize}/${bigImageData?.code}.png`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={bigImageData.title} />)
                              ))
                          }
                          {/* IMAGE PART CAPTION */}
                          {contentPosition === 'insideImage' && (<figcaption> <div className="card_content_title">   {
                            (dataType === 'game' || dataType === 'games') ?
                              <>{(t(`GAME_${bigImageData?.id}`))}</> :
                              ((dataType === 'promotion' || dataType === 'promotions') ?
                                <>{bigImageData?.title}</> :
                                <>{bigImageData?.name}</>
                              )

                          }</div></figcaption>)}

                          {/* --- ACTIVE HOVER (INSIDE IMAGE PART) START --- */}
                          {(isActionVisible || isDesktopOrLaptop)&&actionPosition === 'hover' && <div className="card_action_wrap">
                            {
                              (dataType === 'game' || dataType === 'games') ?
                              <>
                              <button className="color_button font_button button_action button_action1" onClick={(e) => onClickGame(e, bigImageData, { freeCredit: false })}>{bigImageData.action_1 ?? t('play_now')}</button>
                              {bigImageData?.has_free_credit && (<button className="color_button font_button button_action button_action2" onClick={(e) => onClickGame(e, bigImageData, { freeCredit: true })}>{bigImageData.action_2 ?? t('free_credit')}</button>)}
                            </>:
                                ((dataType === 'promotion' || dataType === 'promotions') ?
                                  <>
                                    <button className="color_button font_button button_action button_action1" onClick={() => onChangePromoDetails(bigImageData)} >{bigImageData.action_1 ?? t('more_info')}</button>
                                    {!appState.loggedIn ?
                                      <button className="color_button font_button button_action button_action2">{bigImageData.action_2 ?? t('join_now')}</button> :
                                      <button className="color_button font_button button_action button_action2">{bigImageData.action_2 ?? t('apply_now')}</button>}
                                  </> :
                                  <></>
                                )

                            }


                          </div>}
                          {/* --- ACTIVE HOVER (INSIDE IMAGE PART) END --- */}

                        </figure>
                        {/* --- IMAGE PART END --- */}
                        {(contentPosition !== 'none' && contentPosition !== 'insideImage') && <div className="color_primary content_container">
                          <article className="card_content_wrap">
                            {
                              ((dataType === 'promotion' || dataType === 'promotions') && Array.isArray(bigImageData.category)) &&
                              <div className="promotionTag_part">
                                {bigImageData.category?.map(function (categoryItem, categoryIndex) {
                                  let _categoryItem = dynamicState.allType.find(e => e.code === categoryItem);
                                  return _categoryItem && (
                                    <label key={categoryIndex}>{_categoryItem.name}</label>
                                  )
                                })}

                                {/* <label>New Member</label>
                                  <label>Slot</label>
                                  <label>Live Casino</label> */}
                              </div>
                            }
                            <div className="card_content_title">   {
                              (dataType === 'game' || dataType === 'games') ?
                                <>{(t(`GAME_${bigImageData?.id}`))}</> :
                                ((dataType === 'promotion' || dataType === 'promotions') ?
                                  <>{bigImageData.title}</> :
                                  <>{bigImageData.name}</>
                                )

                            }</div>
                            <div className="card_content_desc_container">
                              {bigImageData.description && (
                                <p className="card_content_desc">{bigImageData.description}</p>
                              )}
                              {
                                ((dataType === 'promotion' || dataType === 'promotions') && isDesktopOrLaptop) && (
                                  <RemainingTime lastEffectiveDate={bigImageData.last_effective_datetime} />
                                )
                              }
                            </div>
                          </article>

                          {/* --- ACTIVE BOTTOM START --- */}
                          {actionPosition === 'bottom' && <div className="card_action_wrap">
                            <div className="button_action_part">
                              {
                                (dataType === 'game' || dataType === 'games') ?
                                <>
                                <button className="color_button font_button button_action button_action1" onClick={(e) => onClickGame(e, bigImageData, { freeCredit: false })}>{bigImageData.action_1 ?? t('play_now')}</button>
                                {bigImageData?.has_free_credit && (<button className="color_button font_button button_action button_action2" onClick={(e) => onClickGame(e, bigImageData, { freeCredit: true })}>{bigImageData.action_2 ?? t('free_credit')}</button>)}
                              </>:
                                  ((dataType === 'promotion' || dataType === 'promotions') ?
                                    <>
                                      <button className="color_button font_button button_action button_action1" onClick={() => onChangePromoDetails(bigImageData)} >{bigImageData.action_1 ?? t('more_info')}</button>
                                      {!appState.loggedIn ?
                                        <Link to="/register" className="color_button font_button button_action button_action2">{bigImageData.action_2 ?? t('join_now')}</Link> :
                                        <Link to="/wallet/transfer" className="color_button font_button button_action button_action2">{bigImageData.action_2 ?? t('apply_now')}</Link>}
                                    </> :
                                    <></>
                                  )

                              } </div>
                            {
                              (dataType === 'promotion' || dataType === 'promotions') &&
                              <div className="promotionCode_part">
                                <label>Use Code</label>
                                <div className="promotionCode_content"><p>{bigImageData?.code}</p> <AiFillCopy onClick={() => copyText(bigImageData?.code)} /></div>
                              </div>
                            }


                          </div>}
                          {/* --- ACTIVE BOTTOM END --- */}
                        </div>}

                      </div>
                    </div>)}
                    {(dynamicState.showData ?? "").slice(1, (rowDesktop * 2) + 1).map((item, index) => (
                      <div className={`small-game card_container ${item?.is_maintenance ? 'maintenance_status' : ''}`}>
                        <div className={`card_wrap card_image_${imageSize} card_position_${contentPosition} card_action_${actionPosition} type_${dataType}`} onClick={(event) => handleLinkClick(event, item)}>
                          {/* --- IMAGE PART START --- */}
                          <figure className={`card_image_wrap  ${item?.coming_soon ? 'coming_soon_image' : ''}`}>
                          {(dataType === 'game provider' && item?.hot) && (
                                <div className="gameProvider_hot_icon">
                                  <img src={`${TENANT_BUCKET}/icon/hot_icon.png`} alt={'hot'} />
                                </div>
                              )}
                              {(dataType === 'game provider' && item?.new) && (
                                <div className="gameProvider_new_icon">
                                  <img src={`${TENANT_BUCKET}/icon/gameProvider_new_icon.png`} alt={'new'} />
                                </div>
                              )}
                            {(dataType === 'game' || dataType === 'games') ?
                              <ImageWithPlaceholder src={`${GLOBAL_BUCKET}/game/${item.game_provider}/${imageSize}/img_jpg/${item.code}_${imageSize}_w${imageSize === '1x2' ? '320' : '150'}.jpg`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={item.title} /> :
                              (dataType === 'game provider' ?
                                <ImageWithPlaceholder src={`${TENANT_BUCKET}/game-provider/${imageSize}/${filter}/${item.game_provider}.png`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={item.title} /> :
                                (dataType === 'gameTypes' ?
                                  <ImageWithPlaceholder src={`${TENANT_BUCKET}/game-type/${imageSize}/${item.code}_${i18n.resolvedLanguage}.png`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={item.title} /> :
                                  ((dataType === 'promotion' || dataType === 'promotions') ?
                                    <ImageWithPlaceholder src={`${isDesktopOrLaptop ? (item._desktop_image?.url) : (item._mobile_image?.url)}`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={item.title} /> :
                                    <ImageWithPlaceholder src={`${GLOBAL_BUCKET}/game/${item.game_provider}/${imageSize}/${item.code}.png`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={item.title} />)
                                ))
                            }
                            {/* IMAGE PART CAPTION */}
                            {contentPosition === 'insideImage' && (<figcaption> <div className="card_content_title">   {
                              (dataType === 'game' || dataType === 'games') ?
                                <>{(t(`GAME_${item?.id}`))}</> :
                                ((dataType === 'promotion' || dataType === 'promotions') ?
                                  <>{item.title}</> :
                                  <>{item.name}</>
                                )

                            }</div></figcaption>)}

                            {/* --- ACTIVE HOVER (INSIDE IMAGE PART) START --- */}
                            {(isActionVisible || isDesktopOrLaptop)&&actionPosition === 'hover' && <div className="card_action_wrap">
                              {
                                (dataType === 'game' || dataType === 'games') ?
                                  <>
                                    <button className="color_button font_button button_action button_action1" onClick={(e) => onClickGame(e, item, { freeCredit: false })}>{item.action_1 ?? t('play_now')}</button>
                                    {item?.has_free_credit && (<button className="color_button font_button button_action button_action2" onClick={(e) => onClickGame(e, item, { freeCredit: true })}>{item.action_2 ?? t('free_credit')}</button>)}
                                  </> :
                                  ((dataType === 'promotion' || dataType === 'promotions') ?
                                    <>
                                      <button className="color_button font_button button_action button_action1" onClick={() => onChangePromoDetails(item)} >{item.action_1 ?? t('more_info')}</button>
                                      {!appState.loggedIn ?
                                        <button className="color_button font_button button_action button_action2">{item.action_2 ?? t('join_now')}</button> :
                                        <button className="color_button font_button button_action button_action2">{item.action_2 ?? t('apply_now')}</button>}
                                    </> :
                                    <></>
                                  )

                              }


                            </div>}
                            {/* --- ACTIVE HOVER (INSIDE IMAGE PART) END --- */}

                          </figure>
                          {/* --- IMAGE PART END --- */}
                          {(contentPosition !== 'none' && contentPosition !== 'insideImage') && <div className="color_primary content_container">
                            <article className="card_content_wrap">
                              {
                                ((dataType === 'promotion' || dataType === 'promotions') && Array.isArray(item.category)) &&
                                <div className="promotionTag_part">
                                  {item.category?.map(function (categoryItem, categoryIndex) {
                                    let _categoryItem = dynamicState.allType.find(e => e.code === categoryItem);
                                    return _categoryItem && (
                                      <label key={categoryIndex}>{_categoryItem.name}</label>
                                    )
                                  })}

                                  {/* <label>New Member</label>
                                  <label>Slot</label>
                                  <label>Live Casino</label> */}
                                </div>
                              }
                              <div className="card_content_title">   {
                                (dataType === 'game' || dataType === 'games') ?
                                  <>{(t(`GAME_${item?.id}`))}</> :
                                  ((dataType === 'promotion' || dataType === 'promotions') ?
                                    <>{item.title}</> :
                                    <>{item.name}</>
                                  )

                              }</div>
                              <div className="card_content_desc_container">
                                {item.description && (
                                  <p className="card_content_desc">{item.description}</p>
                                )}
                                {
                                  ((dataType === 'promotion' || dataType === 'promotions') && isDesktopOrLaptop) && (
                                    <RemainingTime lastEffectiveDate={item.last_effective_datetime} />
                                  )
                                }
                              </div>
                            </article>

                            {/* --- ACTIVE BOTTOM START --- */}
                            {actionPosition === 'bottom' && <div className="card_action_wrap">
                              <div className="button_action_part">
                                {
                                  (dataType === 'game' || dataType === 'games') ?
                                    <>
                                      <button className="color_button font_button button_action button_action1" onClick={(e) => onClickGame(e, item, { freeCredit: false })}>{item.action_1 ?? t('play_now')}</button>
                                      {item?.has_free_credit && (<button className="color_button font_button button_action button_action2" onClick={(e) => onClickGame(e, item, { freeCredit: true })}>{item.action_2 ?? t('free_credit')}</button>)}
                                    </> :
                                    ((dataType === 'promotion' || dataType === 'promotions') ?
                                      <>
                                        <button className="color_button font_button button_action button_action1" onClick={() => onChangePromoDetails(item)} >{item.action_1 ?? t('more_info')}</button>
                                        {!appState.loggedIn ?
                                          <Link to="/register" className="color_button font_button button_action button_action2">{item.action_2 ?? t('join_now')}</Link> :
                                          <Link to="/wallet/transfer" className="color_button font_button button_action button_action2">{item.action_2 ?? t('apply_now')}</Link>}
                                      </> :
                                      <></>
                                    )

                                } </div>
                              {
                                (dataType === 'promotion' || dataType === 'promotions') &&
                                <div className="promotionCode_part">
                                  <label>Use Code</label>
                                  <div className="promotionCode_content"><p>{item?.code}</p> <AiFillCopy onClick={() => copyText(item?.code)} /></div>
                                </div>
                              }


                            </div>}
                            {/* --- ACTIVE BOTTOM END --- */}
                          </div>}
                        </div>
                      </div>
                      // <div className="small-game"><img src="https://storage.googleapis.com/images.imbaweb.com/game/NT/1x1/img/214_41_1x1_w150.png" alt="Small Game 1" /></div>
                      // <div className="small-game"><img src="https://storage.googleapis.com/images.imbaweb.com/game/NT/1x1/img/214_41_1x1_w150.png" alt="Small Game 2" /></div>
                      // <div className="small-game"><img src="https://storage.googleapis.com/images.imbaweb.com/game/NT/1x1/img/214_41_1x1_w150.png" alt="Small Game 3" /></div>
                      // <div className="small-game"><img src="https://storage.googleapis.com/images.imbaweb.com/game/NT/1x1/img/214_41_1x1_w150.png" alt="Small Game 4" /></div>
                      // <div className="small-game"><img src="https://storage.googleapis.com/images.imbaweb.com/game/NT/1x1/img/214_41_1x1_w150.png" alt="Small Game 5" /></div>
                      // <div className="small-game"><img src="https://storage.googleapis.com/images.imbaweb.com/game/NT/1x1/img/214_41_1x1_w150.png" alt="Small Game 1" /></div>
                      // <div className="small-game"><img src="https://storage.googleapis.com/images.imbaweb.com/game/NT/1x1/img/214_41_1x1_w150.png" alt="Small Game 2" /></div>
                      // <div className="small-game"><img src="https://storage.googleapis.com/images.imbaweb.com/game/NT/1x1/img/214_41_1x1_w150.png" alt="Small Game 3" /></div>
                    ))}
                  </div></>)}
                </div>


                {/* --- SECTION BODY END --- */}

              </Container></div></div>
        </section >
        <TransferBalanceDialog show={transferDialogShow.show} onHide={() => setTransferDialogShow({ ...transferDialogShow, show: false })} balance={transferDialogShow.balance} gameSelect={transferDialogShow.gameSelect} walletAmount={transferDialogShow.walletAmount} />
        {isLoading && <Loading />}
        {isLoadingTransfer && <Loading message={'Transferring funds to the game ...'} />}
        {(iframeShow) && (<div className="iframeContainer">
          <div className="closeIframe" onClick={closeIframe}><button>X Close</button></div>
          {showPngGameLauncher && (<PngGameLauncher gameUrl={pngGameSetup?.gameUrl} eventTypes={pngGameSetup?.eventTypes} />)}
          {showPlaytechGameLauncher && (<PlayTechGameLauncher ref={playtechGameLauncherRef} {...playtectParams} />)}
        </div>)}

        {/* TRANSFER GAME CANCEL PROMOTION DIALOG */}
        <Modal show={showGameCancelPromotionDialog} onHide={() => setShowGameCancelPromotionDialog(false)} centered id="gameProviderLockedDialog">
          <Modal.Header>
            <Modal.Title>{t('transferGameCancelPromotion_title')}</Modal.Title>
            {/* <Modal.Title>{t('reminder')}</Modal.Title> */}
          </Modal.Header>
          <Modal.Body>
            <p>{t('transferGameCancelPromotion_content')}</p>
          </Modal.Body>
          <Modal.Footer>
            <button className="cancel_button" onClick={() => {
              if (dynamicState?.selectedData) {
                const { game, details } = dynamicState?.selectedData;
                const updatedDetails = {
                  ...details,
                  confirmUnlock: false
                };
                onClickGame({}, game, updatedDetails);
                setShowGameCancelPromotionDialog(false)
              }
            }} >
              {t('cancel')}
            </button>
            <button className="confirm_button" onClick={() => {
              if (dynamicState?.selectedData) {
                const { game, details } = dynamicState?.selectedData;
                const updatedDetails = {
                  ...details,
                  confirmUnlock: true
                };
                onClickGame({}, game, updatedDetails);
                setShowGameCancelPromotionDialog(false)
              }
            }} >
              {t('confirm')}
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  };
}


export default Template_03;
